export const BaseShifts = [
  { icon: 'fa-sunrise', control: 'fd' },
  { icon: 'fa-sun-bright', control: 'zd' },
  { icon: 'fa-clock', control: 'sd' },
  { icon: 'fa-moon-stars', control: 'nd' },
];
